import { FC } from 'react';
import { InView } from 'react-intersection-observer';
import { WithPreloaderHOC } from 'shared/ui/spinner';

interface GridViewProps extends WithPreloaderHOC {
	onScrollEnd?: () => void;
}

export const GridView: FC<GridViewProps> = ({ onScrollEnd }) => {
	return (
		<InView
			as="div"
			style={{ padding: '2px', marginTop: '-19px' }}
			onChange={(inView, _) => {
				if (inView && onScrollEnd) {
					onScrollEnd();
				}
			}}
		/>
	);
};
